import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import Error404View from "../views/Error404View.vue";
import PolicyPrivacyView from "../views/PolicyPrivacyView.vue";
import ContactView from "../views/ContactView.vue";
import ContactResponseView from "../views/ContactResponseView.vue";
import AboutView from "../views/AboutView.vue";
import ProductListView from "../views/ProductListView.vue";
import ProductItemView from "../views/ProductItemView.vue";
import PartnersView from "../views/PartnersView.vue";
import DistributorsView from "../views/DistributorsView.vue";
// import UnderConstructionView from "../views/UnderConstructionView.vue";

Vue.use(VueRouter);

const routes = [
  {
    name: "Início",
    path: "/",
    component: HomeView,
  },
  {
    name: "Fale Conosco",
    path: "/fale-conosco",
    component: ContactView,
  },
  {
    name: "Quem somos",
    path: "/quem-somos",
    component: AboutView,
  },
  {
    name: "Parceiros",
    path: "/parceiros",
    component: PartnersView,
  },
  {
    name: "Distribuidores",
    path: "/distribuidores",
    component: DistributorsView,
  },
  {
    name: "Produtos",
    path: "/produtos/:category?",
    component: ProductListView,
  },
  {
    name: "Produto",
    path: "/produtos/:category/:product",
    component: ProductItemView,
  },
  {
    name: "Obrigado!",
    path: "/fale-conosco/obrigado",
    component: ContactResponseView,
  },
  {
    name: "Política de Privacidade",
    path: "/politica-de-privacidade",
    component: PolicyPrivacyView,
  },
  {
    path: "/erro404",
    name: "Erro 404",
    component: Error404View,
  },
  {
    path: "*",
    name: "Erro 404",
    component: Error404View,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes,
});

export default router;
